export const PERSONAL_INFORMATION = 'PERSONAL INFORMATION'
export const IDENTITY_VERIFICATION = 'IDENTITY VERIFICATION'
export const EMPLOYMENT_DETAILS = 'EMPLOYMENT DETAILS'
export const accountHolderFormsList = [
  PERSONAL_INFORMATION, 
  IDENTITY_VERIFICATION, 
  EMPLOYMENT_DETAILS
]
export default accountHolderFormsList



// WEBPACK FOOTER //
// ./src/utils/accountHolderFormsList.js